<div class="container-fluid policy-bg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-8 banner-content pe-0 pe-lg-5 ">
                <h1 class="banner-heading-one py-3">Privacy Policy</h1>
            </div>
            <div class="col-lg-4 banner-content banner-sub-img">
                <img src="../../../../../assets/company/legal-policies/privacy-policy.svg" class="img-fluid" alt="privacy-policy">
            </div>
        </div>
    </div>
</div>
<div class="privacy-policybody">
    <div class="container pb-5">
        <div class="row">
            <div class="col-md-12">
                <p class="pt-5 pb-3">Kalpita Technologies (collectively "we," "us," or "our") is committed to protecting
                    the privacy of its
                    users. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information
                    when
                    you visit our website. </p>
                <!-- Information We Collect.............................................. -->
                <h4>Information We Collect </h4>
                <ul>
                    <li class="info-list"><strong>Personal Information : </strong>When you use our services, we may
                        collect personal
                        information such as your name, email address, phone number, address, and payment information.
                    </li>
                    <li class="info-list"><strong>Usage Data : </strong>We may collect information about how you
                        interact with our website
                        or use our services. This includes IP addresses, device information, browser type, pages
                        visited, and access times.</li>
                    <li class="info-list"><strong>Cookies : </strong>We use cookies and similar tracking technologies to
                        enhance your
                        experience, analyze usage patterns, and personalize content. You can manage your cookie
                        preferences through your browser settings.</li>
                </ul>
                <!-- How We Use Your Information ...................................................... -->
                <h4>How We Use Your Information </h4>
                <p>We use the information we collect or receive for the following purposes : </p>
                <ul>
                    <li class="info-list">To provide and maintain our services.</li>
                    <li class="info-list">To personalize your experience and improve our offerings.</li>
                    <li class="info-list">To communicate with you regarding updates, news, or marketing materials. </li>
                    <li class="info-list">To analyze usage trends and enhance the functionality of our website and
                        services. </li>
                    <li class="info-list">To comply with legal obligations or resolve disputes. </li>
                </ul>

                <!-- Data Sharing and Disclosure ................................................................. -->
                <h4>Data Sharing and Disclosure </h4>
                <p>We may share your information with third parties in the following circumstances :</p>
                <ul>
                    <li class="info-list">With service providers or business partners who assist us in delivering our
                        services. </li>
                    <li class="info-list">In response to legal requests, such as court orders or government inquiries.
                    </li>
                    <li class="info-list">To protect our rights, property, or safety and that of our users or others.
                    </li>
                </ul>

                <!-- Data Security ............................................................................. -->
                <h4>Data Security </h4>
                <p>We implement appropriate technical and organizational measures to protect your information from
                    unauthorized access, alteration, disclosure, or destruction. </p>

                <!-- Cookies and Other Tracking................................................................... -->
                <h4>Cookies and Other Tracking </h4>
                <p>To know more about our cookie usage please visit: <a href="company/legal/kalpita-cookie-policy"
                        (click)="nav('company/legal/kalpita-cookie-policy')">Cookie Policy</a> </p>

                <!-- Your Choices and Rights ...................................................................... -->
                <h4>Your Choices and Rights </h4>
                <p>You have the right to access, correct, or delete your personal information. You can also opt out of
                    receiving marketing communications from us anytime.</p>

                <!-- Children's Privacy  ...................................................................... -->
                <h4>Children's Privacy </h4>
                <p>Our services are not directed to children under the age of 13. We do not knowingly collect personal
                    information from individuals under 13. </p>

                <!-- Changes to This Privacy Policy   ...................................................................... -->
                <h4>Changes to This Privacy Policy </h4>
                <p>We reserve the right to update or modify this Privacy Policy at any time. We encourage you to review
                    this page periodically for any changes. </p>

                <!-- Contact Us................................................................... -->
                <h4>Contact Us </h4>
                <p>If you have any questions or concerns about this Privacy Policy, please get in touch with us at <a href="mailto:connect@kalpitatechnologies.com"
                    target="_blank"> connect&#64;kalpitatechnologies.com</a></p>
    
            </div>
        </div>
    </div>

</div>